import { Component, OnInit, ViewEncapsulation,  Input, Output, EventEmitter  } from '@angular/core';
import {FormControl, FormBuilder, FormGroup, Validators} from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import Swal from 'sweetalert2';

//SERVICE
import { ForAllService } from "../services/forall.service";
import { MatSnackBar } from "@angular/material/snack-bar";

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import *  as $ from 'jquery';

@Component({
    selector     : 'native',
    templateUrl  : './native.component.html',
    styleUrls    : ['./native.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class NativeComponent {
      displayedColumns = ['practice', 'description', 'statement1', 'statement2'];
      // displayedColumns = ['practice', 'description'];
      dataSource :any;
      @Input('pasoCompleto') pasoCompleto?: boolean;
      numPractices : number;
      statement1 : string;
      statement2 : string;
      nombreEmpresa: string;
      statement1Part1: string;
      statement1Part2: string;
      statement2Part1: string;
      statement2Part2: string;

      cargando = true;
      formGroupForAll: FormGroup;
      instituto:any;

      @Output() formValido: EventEmitter<boolean> = new EventEmitter();
      @Output() actualizaTraducciones: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private forallService: ForAllService,
    public snackBar: MatSnackBar,
    private translate: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService,) {

    this.getParams();
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    console.log('ID_EMPRESA : '+this.getCompanyID());
    this.obtieneInstituto();

  }
  practica_avanzar:boolean=true;
  descrip__avanzar:boolean=true;

  avanzar:boolean=true;

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    // console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
case '2': case 'CAyC': this.instituto = 'CAyC'; break;
case '3': case 'HK': this.instituto = 'HK'; break;
case '4': case 'SGP': this.instituto = 'SGP'; break;
case '5': case 'TK': this.instituto = 'TK'; break;
case '6': case 'FL': this.instituto = 'FL'; break;
case '11': case 'BR': this.instituto = 'BR'; break;
      // case '6': case 'VIET': this.instituto = 'VIET'; break;
    }
    console.log("Instituto "+this.instituto);
  }

  private updateText(event,idtxt,posicion){

    if(event.target.value.length >= 1){

        //Do you know or have you participated in $replace1 in your workplace?
        this.dataSource.find(x=>x.position == posicion).statement1 = this.statement1.replace('$replace1',event.target.value);

        this.dataSource.find(x=>x.position == posicion).practice = event.target.value;

        //Do you think $replace1 is a good initiative at $replace2?
        //this.dataSource.find(x=>x.position == posicion).statement2 =
        //this.statement2.replace('$replace1',event.target.value).replace('$replace2',this.nombreEmpresa);
        this.dataSource.find(x=>x.position == posicion).statement2 = this.statement2.replace('$replace1',event.target.value)
          .replace('$replace2',this.nombreEmpresa);

    }

  }

  private onBlurPractica(event,idtxt,posicion){
    if(event.target.value.length >= 1){
      if(this.avanzar){
        this.avanzar=false;
        $(document).ready(function(){ $(':focus').blur(); });
        this.modalCargaPractica();
        let data = {
          "fechaCertificar": localStorage.getItem('fechaProducto'),
          "orden": posicion,
          "practicaForall":  event.target.value,
          "statement1":  this.statement1.replace('$replace1',event.target.value),
          "statement2":  this.statement2.replace('$replace1',event.target.value).replace('$replace2',this.nombreEmpresa)+' ?'
        };
        this.forallService.registerForall(data)
          .subscribe(response => {

            if(response['message'] == 'Success'){
              this.avanzar=true;
              this.openSuccessSnackBar(this.translate.instant('CERTIFICAR.FORALL.MSJ_PRACTICEREGISTERED'),this.translate.instant('ALERTS.OK'));
              this.actualizaTraducciones.emit(true);
              Swal.close();
              //this.openSuccessSnackBar('Practice saved succesfully','OK');
            }

            }, error => {
              console.log(error);
        });
      }else{
        console.log("Más despacio velocista, aún no se guarda la práctica");
      }
      /*this.modalCargaPractica();
        let data = {
          "fechaCertificar": localStorage.getItem('fechaProducto'),
          "orden": posicion,
          "practicaForall":  event.target.value,
          "statement1":  this.statement1.replace('$replace1',event.target.value),
          "statement2":  this.statement2.replace('$replace1',event.target.value).replace('$replace2',this.nombreEmpresa)+' ?'
          };

         this.forallService.registerForall(data)
          .subscribe(response => {

            if(response['message'] == 'Success'){
              this.openSuccessSnackBar(this.translate.instant('CERTIFICAR.FORALL.MSJ_PRACTICEREGISTERED'),this.translate.instant('ALERTS.OK'));
              this.actualizaTraducciones.emit(true);
              Swal.close();
              //this.openSuccessSnackBar('Practice saved succesfully','OK');
            }

            }, error => {
              console.log(error);
        }); */
    }
  }

  modalCargaPractica(){
    let mensaje: string;
    this.translate.get('CERTIFICAR.FORALL.CARGANDO_PRACTICA').subscribe((res: string) => { mensaje = res; });

    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
  }

  private onBlurDescripcion(event,idtxt,posicion){
    if(event.target.value.length >= 1){
      if(this.avanzar){
        this.avanzar=false;
        $(document).ready(function(){ $(':focus').blur(); });
        this.modalCargaDescripccion();
        let data = {
          "fechaCertificar": localStorage.getItem('fechaProducto'),
          "orden": posicion,
          "descripcionForall":  event.target.value
        };
        this.forallService.registerForall(data)
        .subscribe(response => {

          if(response['message'] == 'Success'){
            this.avanzar=true;
            this.openSuccessSnackBar(this.translate.instant('CERTIFICAR.FORALL.MSJ_DESCRIPTIONREGISTERED'),this.translate.instant('ALERTS.OK'));
            this.actualizaTraducciones.emit(true);
            Swal.close();

          }

        }, error => {
          console.log(error);
        });

      }else{
        console.log("Más despacio velocista, aún no se guarda la descripción");
      }
      //this.modalCargaDescripccion();

        /*let data = {
              "fechaCertificar": localStorage.getItem('fechaProducto'),
              "orden": posicion,
              "descripcionForall":  event.target.value
        };*/

       /*this.forallService.registerForall(data)
        .subscribe(response => {

          if(response['message'] == 'Success'){
            this.openSuccessSnackBar(this.translate.instant('CERTIFICAR.FORALL.MSJ_DESCRIPTIONREGISTERED'),this.translate.instant('ALERTS.OK'));
            this.actualizaTraducciones.emit(true);
            Swal.close();

          }

          }, error => {
            console.log(error);
          }); */
      }
  }

  modalCargaDescripccion(){
    let mensaje: string;
    this.translate.get('CERTIFICAR.FORALL.CARGANDO_DESCRIPCION').subscribe((res: string) => { mensaje = res; });

    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
  }

  private getParams(){
  let data = {"fechaCertificar": localStorage.getItem('fechaProducto')};
    this.forallService.getParams(data)
    .subscribe(response => {
      console.log("params");
      console.log(response);
      this.numPractices = response['objeto']['numPracticas'];
      this.statement1 = response['objeto']['statement1Nativo'];
      this.statement2 = response['objeto']['statement2Nativo'];
      this.nombreEmpresa = response['empresa'];
      var splitted1 = response['objeto']['statement1Nativo'].split("$replace1");
      var splitted2 = response['objeto']['statement2Nativo'].split("$replace1");
      this.statement1Part1 = splitted1[0];
      this.statement1Part2 = splitted1[1];
      this.statement2Part1 = splitted2[0];
      this.statement2Part2 = splitted2[1].replace("$replace2","");
      localStorage.setItem('numPracticas',''+this.numPractices);


      this.getPracticesSaved();

    }, error => {
      console.log("error", error);
    });
  }

  private getPracticesSaved(){
    let data = {"fechaCertificar": localStorage.getItem('fechaProducto')};

    this.forallService.getPracticesSaved(data)
      .subscribe(response => {
        console.log("get pratice");
        console.log(response);

        this.actualizaTraducciones.emit(true);

      let status = response['message'];
      let res = [];

      if(status == 201){

          for (let i = 0; i < this.numPractices; i++) {
              res.push(
                  {position: i,
                    practice: '',
                    description: '',
                    statement1: '',
                    statement2: '',
                    statement1Part1: this.statement1Part1,
                    statement1Part2: this.statement1Part2,
                    statement2Part1: this.statement2Part1,
                    statement2Part2: this.statement2Part2
                  });
              }
          this.dataSource = res;
          this.creaFormGroups();
          this.cargando = false;
      }else{


          for (let i = 0; i < response['practicas'].length; i++) {

            res.push(
                {position: response['practicas'][i]['orden'],
                  practice: response['practicas'][i].hasOwnProperty('practicaForall') ?
                              response['practicas'][i]['practicaForall'] : '',
                  description: response['practicas'][i].hasOwnProperty('descripcionForall') ?
                                response['practicas'][i]['descripcionForall'] : '',
                  statement1: response['practicas'][i]['statement1'],
                  statement2: response['practicas'][i]['statement2'],
                  statement1Part1: this.statement1Part1,
                  statement1Part2: this.statement1Part2,
                  statement2Part1: this.statement2Part1,
                  statement2Part2: this.statement2Part2
                });

          }

          if(this.numPractices > response['practicas'].length){

            let total = response['practicas'].length;
            let responseRest = (this.numPractices - total);

            for (let i = 0; i < responseRest; i++) {
                    total = total +1 ;
            res.push(
                {position: total,
                  practice: '',
                  description: '',
                  statement1: '',
                  statement2: '',
                  statement1Part1: this.statement1Part1,
                  statement1Part2: this.statement1Part2,
                  statement2Part1: this.statement2Part1,
                  statement2Part2: this.statement2Part2
                });
            }
          }
          this.dataSource = res;
          this.creaFormGroups();
          this.cargando = false;
      }

    }, error => {
      console.log("error", error);
    })

  }

  creaFormGroups(){
    let group = {};
    let iterador = 0;
    this.dataSource.forEach( (objeto) => {
      group["practica"+iterador] = new FormControl({ value: '', disabled: this.pasoCompleto });
      group["descrip"+iterador] = new FormControl({ value: '', disabled: this.pasoCompleto });
      iterador++;
    });
    this.formGroupForAll = new FormGroup(group);
    this.formGroupForAll.valueChanges.subscribe( (res) => {
      if(this.formGroupForAll.status == 'VALID'){
        this.formValido.emit(true);
        console.log('formulario completo');
      }
      else{
        this.formValido.emit(false);
        console.log('formulario incompleto');
      }
    }
    );
  }

  openErrorSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 5000,
         verticalPosition: 'top',
         panelClass: ['background-red']
      });
   }


   openSuccessSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 5000,
         verticalPosition: 'top',
         panelClass: ['background-success']
      });
   }

   getCompanyID():string{
     const token = localStorage.getItem('companyID');
     return token;
   }

   validate(){
     let response = "{\"gptw\":{\"logo\":\"..\/assets\/images\/logo\/logoGPTW2.png\",\"name\":\"Great Place To Work (r) 2019\"},\"screens\":[{\"screenId\":1,\"screenName\":\"Welcome\",\"customContent\":{\"buttons\":{\"next\":{\"label\":\"Next\"}},\"header\":{\"logo\":\"replace1\",\"title\":\"replace2\"},\"text\":\"<h1><b>Welcome<\/b><\/h1><br\/>\"}},{\"screenId\":2,\"screenName\":\"Instructions\",\"customContent\":{\"buttons\":{\"previous\":{\"label\":\"Previous\"},\"start\":{\"label\":\"Start\"},\"continue\":{\"label\":\"Continue\"}},\"header\":{\"title\":\"replace2\"},\"text\":\"<p><h3><b>Survey Instructions<\/b><\/h3><br\/><p>Welcome to the Ingram Micro Philippines Great Place to Work® Survey.<\/p><p>This survey is designed to give you the opportunity to tell us how you feel about your workplace experience.<\/p><p>To the end of the survey, you will also have the opportunity to share your personal views on what makes your organization an excellent place to work and your suggestions for improvement.<\/p><p>The Great Place to Work® The survey requires double perspective responses from you.<\/p><p><strong>For each statement, you must provide 2 responses: by Workgroup and by Organization .<\/strong><br>Check your answers based on your experience using the following definitions:<\/p><strong>'Workgroup'<\/strong> refers to your experience within your Department / Immediate team / Tower<strong>'Organization'<\/strong> refers to your overall experience working in Ingram Micro and Ingram Micro GBS<strong>'Management'<\/strong> under <strong>'Workgroup'<\/strong> refers to your direct manager / immediate supervisor / tower managers<br><strong>'Management'<\/strong> under <strong>'Organization'<\/strong> refers to your organization’s Ingram Micro Senior Management / Ingram Micro GBS Senior Leadership Team<\/p><\/p>\"}},{\"screenId\":3,\"screenName\":\"Survey\",\"customContent\":{\"generics\":{\"requiredText\":\"* This a question is required\"},\"bandRequired\":{\"active\":true,\"text\":\"* This a question is required\"},\"header\":{\"logo\":\"replace1\",\"title\":\"replace2\"},\"instructions\":{\"active\":true,\"text\":\"<p><h3>Survey Instructions<\/h3><br\/>Thank you for participating in the Great Place to Work® Survey. This survey is designed to give you the opportunity to tell us how you feel about your work experience. You will have the opportunity to evaluate both your work and the overall organization as a place to work in a variety of areas. Towards the end of the survey, you also have the opportunity to share your personal views on what makes your organization an excellent place to work, and your suggestions for improvements.<\/p><p>The Great Place to Work Survey requires dual perspective responses from you. Verify your answers based on your experience using the following definitions:<\/p><strong>'Workgroup'<\/strong> refers to your experience within your Department / Immediate team / Tower<br><strong>'Organization'<\/strong> refers to your overall experience working in Ingram Micro and Ingram Micro GBS<br><strong>'Management'<\/strong> under <strong>'Workgroup'<\/strong> refers to your direct manager / immediate supervisor / tower managers<br><strong>'Management'<\/strong> under <strong>'Organization'<\/strong> refers to your organization’s Ingram Micro Senior Management / Ingram Micro GBS Senior Leadership Team <br><p>The survey administration period is December 2, 2019 to December 15, 2019. It will take approximately 15 minutes to complete the survey. Ideally, you should complete the survey at once, but if you are unable to do so, click Save and exit to leave the survey. You will be directed to where you went the next time you logged in. Once you have done this, review your answers and then click Submit.<p/><p><strong>Ingram Micro is committed to providing you with a better workplace experience. Therefore, your comments are important to us. Thank you for taking the time to respond to the survey.<\/strong><\/p>\",\"button\":{\"label\":\"Instructions\"}},\"definitions\":{\"active\":true,\"text\":\"<p><h3>Survey Definitions<\/h3><br\/>The Great Place to Work® survey requires dual perspective responses from you. Verify your answers based on your experience using the following definitions:</p><p><strong>'Workgroup'</strong> refers to your experience within your Department / Immediate team / Tower<br><strong>'Organization'</strong> refers to your overall experience working in Ingram Micro and Ingram Micro GBS<br><strong>'Management'</strong> under <strong>'Workgroup'</strong> refers to your direct manager / immediate supervisor / tower managers<br><strong>'Management'</strong> under <strong>'Organization'</strong> refers to your organization’s Ingram Micro Senior Management / Ingram Micro GBS Senior Leadership Team </p>\",\"active\":true}},\"workgroup\":{\"title\":\"Workgroup Perspective\",\"tooltip\":{\"text\":\"<b>Working group<\/b> refers to your experience within your department. <\/br> <b> Management <\/b> in <b> Working group <\/b> refers to your supervisor \/ direct manager.\",\"active\":true}}},\"pagination\":{\"buttons\":{\"next\":\"Next\",\"previous\":\"Previous\",\"finish\":\"Finish\"}}}},{\"screenId\":4,\"screenName\":\"Survey\",\"customContent\":{\"header\":{\"logo\":\"replace1\",\"title\":\"replace2\"},\"logout\":[{\"type\":1,\"message\":\"You have successfully completed the survey.<br\/> <br\/><b>Thank you for participating!<\/b>\"},{\"type\":2,\"message\":\"You hasn\u00B4t finished answering the survey.<\/br><\/br><b>\u00A1We hope you\u00B4ll be back soon!<\/b>\"}]}}],\"windowLogout\":{\"title\":\"Incomplete answers!\",\"text\":\"<p>Not all survey questions have been answered yet.<br\/> The omitted questions have been marked with red shading. <br\/> To return to the survey, click <b> Previous <\/b> . <br\/> To save and continue later, click <b> Save and exit <\/b>. <br\/> To send your survey <\/p>.\",\"buttons\":{\"saveAndExit\":\"Save and Exit\",\"previous\":\"Previous\",\"logout\":\"Log out\"}},\"windowFinish\":{\"title\":\"Finish survey\",\"text\":\"<p>You have already answered all of the survey questions.<br\/> <br\/> To send your survey, click on <b> Send <\/b> <\/p>.\",\"buttons\":{\"close\":\"Send\"}}}";
   }

   getestatusform(){
     return this.formGroupForAll.status;
   }


}
